import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Switch } from 'react-router-dom';

import AuthRoute from '../components/auth-route';
import Integration from '../sub-projects/integration/main';
// import UnauthRoute from '../components/unauth-route';
import Integrations from '../sub-projects/integrations/main';

class IntegrationsRoutes extends React.Component<any, any> {
  public render() {
    return (
      <div>
        <Switch>
          <AuthRoute exact={true} path='/console/tenants/:tenantid/integrations' component={Integrations} redirectTo='/' />
          <AuthRoute path='/console/tenants/:tenantid/integrations/:integrationid' component={Integration} redirectTo='/' />
          <Redirect to='/' />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default connect(
  mapStateToProps
)(IntegrationsRoutes);




// WEBPACK FOOTER //
// ./src/routes/integrations.tsx